import config from "../config";
const { socketHostname: socketUrl, glSocketHostname: glSocketUrl } = config;

const AvroCodec = require('avroschema');
const AjjasCodec = require("ajjascodec/min");

const user = JSON.parse(window.localStorage.getItem("user"));
const SHORT_PING_DUR = 5000;
const LONG_PING_DUR = 30000;

class WebSocketClient {
  constructor(props) {
    this.onConnect();

    this.retryInterval = 2000;
    this.retryIntervalId = null;
    this.gotPong = false;
    this.pingCounter = 0;
  }

  onConnect() {
    this.socket = new WebSocket(`${user ? glSocketUrl : socketUrl}/wss${user ? "?cookie=undefined&fromWeb=true&reqver=12.47" : ""}`);
    this.socket.binaryType = 'arraybuffer';

    clearTimeout(this.retryIntervalId);
    this.socket.onopen = () => {
      console.log("Connection to the WebSocket has been Established.");
    };

    this.socket.onmessage = (e) => {
      this.resetPing();

      var isString = typeof e.data === 'string';
      let response;

      if(!isString){
        var resp = AvroCodec.Decode(e.data);
        if(!resp){
          let event;
          let header = AjjasCodec.PCB4Parser.decodeHeader(e.data);
          if(header){
            if(header.headerId >= AjjasCodec.CONSTANTS.PCB4_RES_HEADER_ID){
              event = AjjasCodec.PCB4Parser.decodeEvents(header.buf);
              event.ts = header.ts;
            }
            else{
              event = new AjjasCodec.WIRELESS.WirelessDeviceParser(header.buf, true).parseServerData(false, false, header.ts, true);
              if(typeof event === "string" || !event)
                return console.error(event);
            }

            event.vid = header.vid;
            if(header.headerId == AjjasCodec.WIRELESS.CONSTANTS.RT_HEADER_ID) global.EE.emitEvent(global.EE.EVENT_TYPES.RT_LOC_EVT, event);
            else global.EE.emitEvent(global.EE.EVENT_TYPES.ON_VEHICLE_DATA, event);
          }
        }
        else{
          //ajjas device data
          switch (resp.schema) {
            case AvroCodec.SCHEMA.A_REQ_TIMELINE_EVENT:
              if (resp.obj && resp.obj.meta) {
                var meta = AvroCodec.Decode(resp.obj.meta);
                if (meta && meta.obj) resp.obj.meta = meta.obj;
              }
              global.EE.emitEvent(global.EE.EVENT_TYPES.GET_TL_EVENTS, resp.obj);
              break;
            case AvroCodec.SCHEMA.A_LOC_EVT_REAL_TIME:
              global.EE.emitEvent(global.EE.EVENT_TYPES.RT_LOC_EVT, resp.obj);
              break;
            case AvroCodec.SCHEMA.A_LOC_EVT_RES_FILTER:
              global.EE.emitEvent(global.EE.EVENT_TYPES.ON_VEHICLE_DATA, resp.obj);
              break;
            default: console.log("resp.schema", resp.schema, "resp.obj", resp.obj);
          }

        }
      }
      else {
        if (e.data.length === 1) {
          this.startPingPong(LONG_PING_DUR);
          return;
        }

        try {
          response = JSON.parse(e.data);
        } catch (err) {
          console.log(err);
          return;
        }

        switch (response.a) {
          case "kick": {
            clearTimeout(this.retryIntervalId);
            this.socket.onclose = function () {};
            this.socket.close();
            break;
          }

          default: {
            break;
          }
        }

        if(response.a === "newMsg") {
          global.EE.emitEvent(global.EE.EVENT_TYPES.MESSAGE_RECEIVED, response.d);
        }

        else if (response.a === "sendMessage") {
          global.EE.emitEvent(global.EE.EVENT_TYPES.MESSAGE_SENT, response.d);
        }

        else if (response.a === "msgEvent") {
          global.EE.emitEvent(global.EE.EVENT_TYPES.MESSAGE_EVENT, response.d);
        }

        else if (response.a === "LastSeen" || response.a === "dynamicLastSeen") {
          global.EE.emitEvent(global.EE.EVENT_TYPES.ON_LAST_SEEN, response.d);
        }

        else if(response.a === "getWirelessPings" && response.d && response.d.vid){
          global.EE.emitEvent(global.EE.EVENT_TYPES.ON_VEHICLE_DATA, { ts: 0, vid: response.d.vid, isWireless: true });
        }


        else if (response.a === "relayFromSeller") {
          global.EE.emitEvent(global.EE.EVENT_TYPES.RELAY_STATE, response.d);
        }

        else if (response.a === "relay_done") {
          global.EE.emitEvent(global.EE.EVENT_TYPES.RELAY_DONE, response.d);
        }

        else if (response.a === "relay_err") {
          global.EE.emitEvent(global.EE.EVENT_TYPES.RELAY_ERR, response.d);
        }

        else if (response.a === "wirelessHeartbeat") {
          global.EE.emitEvent(global.EE.EVENT_TYPES.WIRELESS_TESTING_SUCCESSFULL, response.d);
        }

        else if(response.a === "getLiteCmdResp"){
          global.EE.emitEvent(global.EE.EVENT_TYPES.LITE_CMD_RESP, response.d);
        }

        else if (response.a === "bikes") {
          global.EE.emitEvent(global.EE.EVENT_TYPES.ON_BIKES, response.d);
        }

        else if (response.a === "tlStartSharing") {
          global.EE.emitEvent(global.EE.EVENT_TYPES.TIMELINE_START_SHARING, response.d);
        }

        else if (response.a === "tlStopSharing") {
          global.EE.emitEvent(global.EE.EVENT_TYPES.TIMELINE_STOP_SHARING, response.d);
        }

        else if (response.a === "ready") {
          this.wsConnected = true;
          global.EE.emitEvent(global.EE.EVENT_TYPES.WS_CONNECTED);
        }
      }
    };

    this.startPingPong(SHORT_PING_DUR);

    this.socket.onclose = (e) => {
      // console.log("Connection to the WebSocket Closed.");
      if (!e.wasClean) {
        global.EE.emitEvent(global.EE.EVENT_TYPES.WS_DISCONNECTED);
        this.reconnect(e);
      }
    };

    this.socket.onerror = () => {
      // console.log("An Error Ocurred in the WebSocket Connection.");
      this.reconnect();
    };
  }

  resetPing = () => {
    this.gotPong = true;
    this.pingCounter = 0;
  }

  startPingPong = (duration) => {
    clearTimeout(this.pingPongTimeout);

    this.pingPongTimeout = setTimeout(() => {
      this.pingCounter += 1;

      if (this.pingCounter === 5) {
        this.socket.close();
      } else {
        if(this.gotPong) this.startPingPong(duration);
        else this.startPingPong(SHORT_PING_DUR);

        if (this.socket && this.socket.readyState === 1) {
          this.socket.send('p');
          this.gotPong = false;
        }
      }
    }, duration);
  }

  reconnect = (/* e */) => {
    // console.log("WebSocket Reconnecting.");
    this.retryIntervalId = setTimeout(() => {
      this.onConnect();
    }, this.retryInterval);
  };

  sendRequest = ({ action, data }) => {
    const request = JSON.stringify({
      a: action,
      d: data,
    });

    this.socket.send(request);
  };

  closeSocket = () => {
    this.socket.onclose = () => {
      clearTimeout(this.retryIntervalId);
      // console.log("Connection Closed");
      global.globalSocket = null;
    };
    this.socket.close();
  };
}

export default WebSocketClient;
